import { assignedPermissions, profile_types, modules, apiPrefixes, permissions } from "../../../core/components/common/variables/static_variables";
import { useRBACStore } from "../zustand/useRBACStore";

export const useGuard = () => {

  const { currentProfile } = useRBACStore();

  const getPrefixPermission = (requiredPermission, profile_type) => {
    let required_permission = requiredPermission
    for (const prefix of apiPrefixes) {
      if (prefix == 'org') {
        if (profile_type === profile_types.BUSINESS && assignedPermissions.BUSINESS.hasOwnProperty(requiredPermission)) {
            required_permission = "ORG_" + requiredPermission;
            break;
          }
      } else if (prefix == 'assigned') {
        
      }  else if (prefix === 'all') {
        const allPrefixPermissions = [
          permissions.dashboard.DASHBOARD_ACCESSLOGS,
          permissions.dashboard.DASHBOARD_BOOKING,
          permissions.dashboard.DASHBOARD_VEHICLE,
          permissions.dashboard.DASHBOARD_GATEPASS,
          permissions.dashboard.DASHBOARD_CONTAINER,
          permissions.dashboard.DASHBOARD_BOOKING_COMPONENT,
          permissions.dashboard.DASHBOARD_VEHICLE_COMPONENT,
          permissions.dashboard.DASHBOARD_GATEPASS_COMPONENT,
          permissions.dashboard.DASHBOARD_CONTAINER_COMPONENT,
          permissions.dashboard.DASHBOARD_USERS,
        ];

        if (
          allPrefixPermissions.includes(requiredPermission) &&
          profile_type === profile_types.PORT_EMPLOYEE
        ) {
          required_permission = "ALL_" + requiredPermission;

          console.log("required_permission", required_permission);
          break;
        }
      }

    }
    return required_permission;
  };

  const isAllowedUserTypes = (allowedUserTypes, userType = null, role = null, route) => {
    if (!userType) {
      userType = currentProfile?.profileType
    }

    if (!role) {
      role = currentProfile?.role
    }

    if (!allowedUserTypes) return true;

    let isAllowedAccess = allowedUserTypes.some(accessRule => {
      return (
        accessRule.profileType === userType &&
        (!accessRule.roles || accessRule.roles.includes(role))
      );
    });

    return isAllowedAccess
  };

  const hasPermission = (requiredPermission, profile_type = null, current_permissions = null) => {
    if (!requiredPermission) return true;

    if (!profile_type) {
      profile_type = currentProfile?.profileType
    }

    if (!current_permissions) {
      current_permissions = currentProfile?.permissions
    }

    const permission = getPrefixPermission(requiredPermission, profile_type);
    console.log("required_permission bbbb", permission);
    return current_permissions.includes(permission.toLowerCase());
  };


  return { isAllowedUserTypes, hasPermission };
};
